import { generatePath } from "react-router";

import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

export const warrantyAddPath = "/WarrantyAdd/:jobId";
export const warrantyAddRoute = createRoute<{ jobId: number }>(
    getPathForAllPortals(warrantyAddPath),
    "Add Warranty",
);

/**
 * Resolves the destination for "Add a Warranty Claim". For jobId=0, returns
 * a relative QuickAction URL so the picker modal overlays the caller's page —
 * the list route still matches as a prefix, so it stays mounted. Pushing the
 * absolute `warrantyAddRoute.link({ jobId: 0 })` instead lands the modal
 * over a blank `/WarrantyAdd/0`. Every "+ Warranty" entry point must funnel
 * through here.
 */
export function getWarrantyAddNavTarget(parentUrl: string, jobId: number) {
    if (jobId === 0) {
        return `${parentUrl}/QuickAction${generatePath(warrantyAddPath, { jobId })}`;
    }
    return warrantyAddRoute.link({ jobId });
}
